export default __webpack_public_path__ + "static/media/MotionCoinswallet.7d0138f2.png";